import styled from 'styled-components'

export default styled.img`
	width: ${ ( { width='100px' } ) => width };
    height: ${ ( { height='100px' } ) => height };
    border-radius: ${ ( { radius='50%' } ) => radius };
    margin: ${ ( { margin='0' } ) => margin };
`